
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer-and-earn",
      function () {
        return require("private-next-pages/refer-and-earn/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer-and-earn"])
      });
    }
  